import useIsLayoutSize from '../post/utils/useIsLayoutSize';
import { LayoutSize } from '../post/utils/useLayoutSize';

const useCanManageSidebarSections = () => !useIsLayoutSize(LayoutSize.mobile);

export default useCanManageSidebarSections;
